import React from 'react';
import { DataMode, AuthState, ViewMode } from '../types';

interface HorizontalTabsProps {
  activeTab: DataMode;
  onTabChange: (tab: DataMode) => void;
  availableModes: DataMode[];
  authState: AuthState;
  viewMode: ViewMode;
}

const HorizontalTabs: React.FC<HorizontalTabsProps> = ({
  activeTab,
  onTabChange,
  availableModes,
  authState,
  viewMode
}) => {
  const handleTabClick = (tab: DataMode) => {
    onTabChange(tab);
    console.log('Switched to data mode:', tab);
  };

  const getTabClassName = (tab: DataMode): string => {
    const baseClass = 'horizontal-tab';
    const activeClass = activeTab === tab ? 'active' : '';
    const authClass = !authState.isAuthenticated ? 'login-required' : '';
    
    return [baseClass, activeClass, authClass].filter(Boolean).join(' ');
  };

  const getTabTitle = (tab: DataMode): string => {
    if (!authState.isAuthenticated) {
      return `Login required to access ${getTabDisplayName(tab)}`;
    }
    
    switch (tab) {
      case 'central-ps':
        return 'Central PS data from service account';
      case 'my-team':
        return 'Your team members data';
      case 'basic':
        return 'Traditional AI tool usage data';
      default:
        return '';
    }
  };

  const getTabDisplayName = (tab: DataMode): string => {
    switch (tab) {
      case 'basic':
        return 'Basic Data';
      case 'central-ps':
        return 'Central PS';
      case 'my-team':
        return 'My Team';
      default:
        return tab;
    }
  };

  const getTabIcon = (tab: DataMode): string => {
    switch (tab) {
      case 'basic':
        return '📊';
      case 'central-ps':
        return '🏢';
      case 'my-team':
        return '👥';
      default:
        return '';
    }
  };

  return (
    <div className="horizontal-tabs-container">
      <div className="horizontal-tabs">
        {availableModes.map((mode) => (
          <button
            key={mode}
            onClick={() => handleTabClick(mode)}
            className={getTabClassName(mode)}
            title={getTabTitle(mode)}
          >
            <span className="tab-icon">{getTabIcon(mode)}</span>
            <span className="tab-label">{getTabDisplayName(mode)}</span>
            {!authState.isAuthenticated && <span className="lock-icon">🔒</span>}
          </button>
        ))}
      </div>
      
      <div className="tab-indicator" data-active-tab={activeTab} style={{
        width: `${100 / availableModes.length}%`,
        left: `${(availableModes.indexOf(activeTab) * 100) / availableModes.length}%`
      }} />
    </div>
  );
};

export default HorizontalTabs; 